import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { catalogFeaturesService } from "@/services/catalog-features-service";
import { CreateFeatureDto, UpdateFeatureDto } from "@/types/catalog-feature";

export const featureCatalogKeys = {
  all: ["featureCatalog"] as const,
  lists: () => [...featureCatalogKeys.all, "list"] as const,
  list: () => [...featureCatalogKeys.lists()] as const,
};

export const useFeatures = (enabled: boolean) => {
  return useQuery({
    queryKey: featureCatalogKeys.list(),
    queryFn: () => catalogFeaturesService.getFeatures(),
    staleTime: 60 * 1000,
    enabled,
  });
};

export const useUpdateFeature = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: UpdateFeatureDto }) =>
      catalogFeaturesService.patchFeature(id, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: featureCatalogKeys.lists() });
    },
  });
};

export const useCreateFeature = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateFeatureDto) =>
      catalogFeaturesService.createFeature(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: featureCatalogKeys.lists() });
    },
  });
};

export const useDeleteFeature = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => catalogFeaturesService.deleteFeature(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: featureCatalogKeys.lists() });
    },
  });
};
